module.exports = __webpack_public_path__ + "static/media/background-vinzi.d1e6c45.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background-vinzi.webm
// module id = Bcyi
// module chunks = 0